'use client';

import dynamic from 'next/dynamic';

export const VideoAccordion = dynamic(() => import('.'));
